<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="数据总览" name="first">
        <div class="k-page-common">
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-con">
                <el-row style="padding: 5px;">
                  <el-col :span="8" style="padding-right: 5px ;">
                    <el-card class="box-card" v-loading="headerSearch.loading">
                      <div slot="header" class="clearfix">
                        <span style="font-size: 12px;font-weight: bold;">营收总览</span>
                        <div style="float: right;">
                          <el-select v-model="headerSearch.type" :size="size" placeholder="请选择类型" @change="changeType">
                            <el-option label="年度" value="YEAR"></el-option>
                            <el-option label="季度" value="SEASON"></el-option>
                            <el-option label="月度" value="MONTH"></el-option>
                          </el-select>
                          <el-date-picker v-if="headerSearch.type == 'YEAR'" :size="size" @change="(value) => getYingshouData('YEAR', value)"
                            style="margin-left: 10px;width: 150px;" v-model="headerSearch.time" type="year"
                            format="yyyy" value-format="yyyy" placeholder="选择年度">
                          </el-date-picker>
                          <quarter-picker v-if="headerSearch.type == 'SEASON'" :size="size" @change="(value) => getYingshouData('SEASON', value)"
                            style="margin-left: 10px;width: 150px;" v-model="headerSearch.time" format="YYYY-MM"
                            value-format="YYYY-MM" placeholder="选择季度" />
                          <el-date-picker v-if="headerSearch.type == 'MONTH'" :size="size" @change="(value) => getYingshouData('MONTH', value)"
                            style="margin-left: 10px;width: 150px;" v-model="headerSearch.time" type="month"
                            format="yyyy-MM" value-format="yyyy-MM" placeholder="选择月度">
                          </el-date-picker>
                        </div>
                      </div>
                      <div>
                        <el-row type="flex" justify="space-around">
                          <el-col :span="10">
                            <custom-statistic title="项目数" :value="headerSearch.data.project_num" :precision="0"
                              suffix="个" :size="textSize" align="center" :value-style="{ color: '#409EFF' }">
                            </custom-statistic>
                          </el-col>
                          <el-col :span="10">
                            <custom-statistic title="销售额" :value="headerSearch.data.xiaoshou_cost" :precision="2"
                              suffix="万元" :size="textSize" align="center" :value-style="{ color: '#409EFF' }">
                            </custom-statistic>
                          </el-col>
                        </el-row>
                        <el-row type="flex" justify="space-around">
                          <el-col :span="10">
                            <custom-statistic title="利润额" :value="headerSearch.data.lirun_cost" :precision="2"
                              suffix="万元" :size="textSize" align="center" :value-style="{ color: '#409EFF' }">
                            </custom-statistic>
                          </el-col>
                          <el-col :span="10">
                            <custom-statistic title="利润率" :value="headerSearch.data.lirun_rate" :precision="2"
                              suffix="%" :size="textSize" align="center" :value-style="{ color: '#F56C6C' }">
                            </custom-statistic>
                          </el-col>
                        </el-row>
                      </div>
                    </el-card>
                  </el-col>
                  <el-col :span="8" style="padding-left: 5px; padding-right: 5px;">
                    <el-card class="box-card" v-loading="twoSearch.loading">
                      <div slot="header" class="clearfix">
                        <span style="font-size: 12px;font-weight: bold;">回款总览</span>
                        <div style="float: right;">
                          <el-select v-model="twoSearch.type" :size="size" placeholder="请选择类型" @change="changeTwoType">
                            <el-option label="年度" value="YEAR"></el-option>
                            <el-option label="季度" value="SEASON"></el-option>
                            <el-option label="月度" value="MONTH"></el-option>
                          </el-select>
                          <el-date-picker v-if="twoSearch.type == 'YEAR'" :size="size" @change="(value) => getHuikuanData('YEAR', value)"
                            style="margin-left: 10px;width: 150px;" v-model="twoSearch.time" type="year"
                            format="yyyy" value-format="yyyy" placeholder="选择年度">
                          </el-date-picker>
                          <quarter-picker v-if="twoSearch.type == 'SEASON'" :size="size" @change="(value) => getHuikuanData('SEASON', value)"
                            style="margin-left: 10px;width: 150px;" v-model="twoSearch.time" format="YYYY-MM"
                            value-format="YYYY-MM" placeholder="选择季度" />
                          <el-date-picker v-if="twoSearch.type == 'MONTH'" :size="size" @change="(value) => getHuikuanData('MONTH', value)"
                            style="margin-left: 10px;width: 150px;" v-model="twoSearch.time" type="month"
                            format="yyyy-MM" value-format="yyyy-MM" placeholder="选择月度">
                          </el-date-picker>
                        </div>
                      </div>
                      <div>
                        <el-row type="flex" justify="space-around">
                          <el-col :span="10">
                            <custom-statistic title="项目应收总额" :value="twoSearch.data.yingshou_cost" :precision="2"
                              suffix="万元" :size="textSize" align="center" :value-style="{ color: '#409EFF' }">
                            </custom-statistic>
                          </el-col>
                          <el-col :span="10">
                            <custom-statistic title="项目已收总额" :value="twoSearch.data.yishou_cost" :precision="2"
                              suffix="万元" :size="textSize" align="center" :value-style="{ color: '#409EFF' }">
                            </custom-statistic>
                          </el-col>
                        </el-row>
                        <el-row type="flex" justify="space-around">
                          <el-col :span="10">
                            <custom-statistic title="项目回款率" :value="twoSearch.data.huikuan_rate" :precision="2"
                              suffix="%" :size="textSize" align="center" :value-style="{ color: '#F56C6C' }">
                            </custom-statistic>
                          </el-col>
                        </el-row>
                      </div>
                    </el-card>
                  </el-col>
                  <el-col :span="8" style="padding-left: 5px;">
                    <el-card class="box-card" v-loading="threeSearch.loading">
                      <div slot="header" class="clearfix">
                        <span style="font-size: 12px;font-weight: bold;">返点总览</span>
                        <div style="float: right;">
                          <el-select v-model="threeSearch.type" :size="size" placeholder="请选择类型" @change="changeThreeType">
                            <el-option label="年度" value="YEAR"></el-option>
                            <el-option label="季度" value="SEASON"></el-option>
                            <el-option label="月度" value="MONTH"></el-option>
                          </el-select>
                          <el-date-picker v-if="threeSearch.type == 'YEAR'" :size="size" @change="(value) => getFandianData('YEAR', value)"
                            style="margin-left: 10px;width: 150px;" v-model="threeSearch.time" type="year"
                            format="yyyy" value-format="yyyy" placeholder="选择年度">
                          </el-date-picker>
                          <quarter-picker v-if="threeSearch.type == 'SEASON'" :size="size" @change="(value) => getFandianData('SEASON', value)"
                            style="margin-left: 10px;width: 150px;" v-model="threeSearch.time" format="YYYY-MM"
                            value-format="YYYY-MM" placeholder="选择季度" />
                          <el-date-picker v-if="threeSearch.type == 'MONTH'" :size="size" @change="(value) => getFandianData('MONTH', value)"
                            style="margin-left: 10px;width: 150px;" v-model="threeSearch.time" type="month"
                            format="yyyy-MM" value-format="yyyy-MM" placeholder="选择月度">
                          </el-date-picker>
                        </div>
                      </div>
                      <div>
                        <el-row type="flex" justify="space-around">
                          <el-col :span="10">
                            <custom-statistic title="返点应收总额" :value="threeSearch.data.yingshou_point_cost"
                              :precision="2" suffix="万元" :size="textSize" align="center"
                              :value-style="{ color: '#409EFF' }">
                            </custom-statistic>
                          </el-col>
                          <el-col :span="10">
                            <custom-statistic title="返点已收总额" :value="threeSearch.data.yishou_point_cost" :precision="2"
                              suffix="万元" :size="textSize" align="center" :value-style="{ color: '#409EFF' }">
                            </custom-statistic>
                          </el-col>
                        </el-row>
                        <el-row type="flex" justify="space-around">
                          <el-col :span="10">
                            <custom-statistic title="返点回款率" :value="threeSearch.data.point_rate" :precision="2"
                              suffix="%" :size="textSize" align="center" :value-style="{ color: '#F56C6C' }">
                            </custom-statistic>
                          </el-col>
                        </el-row>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
                <!-- <el-row style="padding: 5px;">
                  <el-card class="box-card">
                    <div id="month" style="height: 500px"></div>
                  </el-card>
                </el-row> -->
                <el-row style="padding: 5px;">
                  <el-card class="box-card">
                    <div slot="header">
                      <span style="font-size: 14px;font-weight: bold;">明细列表</span>
                      <div style="float: right;">
                        <el-select v-model="dataListSearch.dimension" :size="size" placeholder="请选择维度"
                          @change="changeDimension">
                          <el-option label="时间维度" value="TIME"></el-option>
                          <el-option label="部门维度" value="DEPARTMENT"></el-option>
                          <el-option label="人员维度" value="USER"></el-option>
                          <el-option label="客户维度" value="CUSTOMER"></el-option>
                        </el-select>
                        <!-- 部门可多选 -->
                        <el-cascader v-if="dataListSearch.dimension == 'DEPARTMENT'"
                          style="margin-left:10px;min-width: 280px;" collapse-tags v-model="dataListSearch.dept_ids"
                          :size="size" :options="options.dept_id_options"
                          :props="{ checkStrictly: true, label: 'department_name', value: 'id', multiple: true }"
                          placeholder="请选择部门" clearable></el-cascader>
                        <!-- 人员可多选 -->
                        <el-select v-if="dataListSearch.dimension == 'USER'" multiple v-model="dataListSearch.uids"
                          filterable remote placeholder="请选择管理人" :size="size" style="margin-left:10px;min-width: 280px;" collapse-tags
                          clearable>
                          <el-option v-for="item in options.uid_options" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>

                        <!-- 客户可多选 -->
                        <el-select v-if="dataListSearch.dimension == 'CUSTOMER'" multiple :size="size"
                          v-model="dataListSearch.customer_ids" filterable remote placeholder="请选择客户" clearable
                          style='margin-left:10px;min-width: 280px;' collapse-tags :remote-method="getCustomerSelect">
                          <el-option v-for="item in options.customer_id_options" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <el-date-picker style="margin-left:10px;" :size="size" v-model="dataListSearch.time"
                          type="monthrange" format="yyyy-MM" value-format="yyyy-MM" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                         <el-button style="margin-left:10px;" :size="size" type="primary">查询</el-button>
                      </div>
                    </div>
                    <el-table :data="dataListSearch.data" border style="width: 100%;" empty-text="该功能暂未开通，等待中...">
                      <el-table-column prop="dimension" label="维度"></el-table-column>
                      <el-table-column prop="cost" label="销售额"></el-table-column>
                      <el-table-column prop="cost_zb_rate" label="营收贡献占比"></el-table-column>
                      <el-table-column prop="profit" label="利润额"></el-table-column>
                      <el-table-column prop="profit_zb_rate" label="利润贡献占比"></el-table-column>
                      <el-table-column prop="profit_rate" label="利润率"></el-table-column>
                      <el-table-column prop="num" label="项目数"></el-table-column>
                      <el-table-column prop="cost_yingshou" label="项目应收总额"></el-table-column>
                      <el-table-column prop="cost_yishou" label="项目已收总额"></el-table-column>
                      <el-table-column prop="cost_return_rate" label="项目回款率"></el-table-column>
                      <el-table-column prop="point_cost" label="返点应收总额"></el-table-column>
                      <el-table-column prop="point_ys_cost" label="返点已收总额"></el-table-column>
                      <el-table-column prop="point_rate" label="返点回款率"></el-table-column>
                    </el-table>
                  </el-card>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import QuarterPicker from '@hey_dino/quarter-picker';
// import * as echarts from 'echarts'
import CustomStatistic from '../../components/Statistic.vue'
export default {
  components: {
    CustomStatistic, QuarterPicker
  },
  data () {
    return {
      headerSearch: {
        type: 'YEAR',
        time: '',
        loading: false,
        data: {
          xiaoshou_cost: 0.00,
          lirun_cost: 0.00,
          lirun_rate: 0.00,
          project_num: 0,
        },
      },
      twoSearch: {
        type: 'YEAR',
        time: '',
        loading: false,
        data: {
          yingshou_cost: 0.00,
          yishou_cost: 0.00,
          huikuan_rate: 0.00,
        },
      },
      threeSearch: {
        type: 'YEAR',
        time: '',
        loading: false,
        data: {
          yingshou_point_cost: 0.00,
          yishou_point_cost: 0.00,
          point_rate: 0.00,
        },
      },
      dataListSearch: {
        loading:false,
        dimension: 'TIME',
        time: [],
        dept_ids: [],
        uids: [],
        data:[]
      },
      loading: false,
      size: 'mini',
      textSize: 'small',
      activeName: 'first',
      options: {
        weiduData: [
          { 'value': 1, 'label': '时间维度' },
          { 'value': 2, 'label': '部门维度' },
          { 'value': 3, 'label': '客户维度' },
        ],
        dept_id_options: [],
        uid_options: [],
        customer_id_options: [],
      }
   }
  },
  computed: {
    tableHeight: function () {
      return window.innerHeight - 320
    },
  },
  mounted: function () {
    this.getDepartmentOption()
    // 默认当年
    let now_time = this.formatDate(new Date())
    this.headerSearch.type = 'YEAR'
    this.headerSearch.time = now_time['year']
    this.twoSearch.type = 'YEAR'
    this.twoSearch.time = now_time['year']
    this.threeSearch.type = 'YEAR'
    this.threeSearch.time = now_time['year']

    this.dataListSearch.dimension = 'TIME'
    this.dataListSearch.time = [`${now_time['year']}-01-01`,`${now_time['year']}-${now_time['month']}-${now_time['day']}`]

    // 获取营收数据
    this.getYingshouData(this.headerSearch.type, this.headerSearch.time)
    // 获取回款数据
    this.getHuikuanData(this.twoSearch.type, this.twoSearch.time)
    // 获取返点数据
    this.getFandianData(this.threeSearch.type, this.threeSearch.time)
    // 获取详细数据
    this.getlist(this.dataListSearch.dimension, this.dataListSearch.time)
  },
  methods: {
    getYingshouData(type, time){
      this.headerSearch.loading = true
      this.$api.get('/admin/customers/customer/getyingshoudata',{'type':type,'time':time}).then(res => {
				if (res.code === 0) {
					this.headerSearch.data = res.data
				} else {
					this.$message.error(res.msg);
				}
        this.headerSearch.loading = false 
			})
    },
    getHuikuanData(type, time){
      this.twoSearch.loading = true
      this.$api.get('/admin/customers/customer/gethuikuandata',{'type':type,'time':time}).then(res => {
				if (res.code === 0) {
					this.twoSearch.data = res.data
				} else {
					this.$message.error(res.msg);
				}
        this.twoSearch.loading = false 
			})
    },
    getFandianData(type, time){
      this.threeSearch.loading = true
      this.$api.get('/admin/customers/customer/getfandiandata',{'type':type,'time':time}).then(res => {
				if (res.code === 0) {
					this.threeSearch.data = res.data
				} else {
					this.$message.error(res.msg);
				}
        this.threeSearch.loading = false 
			})
    },
    getlist(type, time){
      this.dataListSearch.loading = true
      this.$api.get('/admin/customers/customer/getalldata',{'type':type,'time':time}).then(res => {
				if (res.code === 0) {
					this.dataListSearch.data = res.data
				} else {
					this.$message.error(res.msg);
				}
        this.dataListSearch.loading = false 
			})
    },
    formatDate(date) {
      const year = String(date.getFullYear());
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return {'year':year,'month':month,'day':day}
    },
    changeDimension (val) {
      if (val == 'DEPARTMENT') {
        this.getDepartmentOption()
      } else if (val == 'USER') {
        this.getUserSelect()
      } else if (val == 'CUSTOMER') {
        this.getCustomerSelect()
      }
    },
    getCustomerSelect (query) {
      query = query ? query : '';
      this.$api.get('/admin/customers/customer/getcustomerselect', { query: query }).then(res => {
        if (res.code === 0) {
          this.options.customer_id_options = res.data;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getUserSelect (query) {
      query = query ? query : '';
      this.$api.post('/admin/users/user/getuserbydepartment', { query: query }).then(res => {
        if (res.code === 0) {
          this.options.uid_options = res.data;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getDepartmentOption () {
      this.$api.get('/admin/users/user/getDepartmentTree').then(res => {
        if (res.code === 0) {
          this.options.dept_id_options = res.data;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    changeThreeType(val){
      let now_time = this.formatDate(new Date())
      if(val=='YEAR'){
        this.threeSearch.time = now_time['year']
      }else if(val=='SEASON'){
        let quarter = Math.ceil(Number(now_time['month']) / 3); // 计算季度（1-4）
        let firstMonth = String((quarter - 1) * 3 + 1).padStart(2, '0');    // 计算季度第一个月
        this.threeSearch.time = `${now_time['year']}-${firstMonth}`
      }else if(val=='MONTH'){
        this.threeSearch.time = `${now_time['year']}-${now_time['month']}`
      }
      this.getFandianData(val, this.threeSearch.time)
    },
    changeTwoType(val){
      let now_time = this.formatDate(new Date())
      if(val=='YEAR'){
        this.twoSearch.time = now_time['year']
      }else if(val=='SEASON'){
        let quarter = Math.ceil(Number(now_time['month']) / 3); // 计算季度（1-4）
        let firstMonth = String((quarter - 1) * 3 + 1).padStart(2, '0');    // 计算季度第一个月
        this.twoSearch.time = `${now_time['year']}-${firstMonth}`
      }else if(val=='MONTH'){
        this.twoSearch.time = `${now_time['year']}-${now_time['month']}`
      }
      this.getHuikuanData(val, this.twoSearch.time)
    },
    changeType (val) {
      let now_time = this.formatDate(new Date())
      if(val=='YEAR'){
        this.headerSearch.time = now_time['year']
      }else if(val=='SEASON'){
        let quarter = Math.ceil(Number(now_time['month']) / 3); // 计算季度（1-4）
        let firstMonth = String((quarter - 1) * 3 + 1).padStart(2, '0');    // 计算季度第一个月
        this.headerSearch.time = `${now_time['year']}-${firstMonth}`
      }else if(val=='MONTH'){
        this.headerSearch.time = `${now_time['year']}-${now_time['month']}`
      }
      this.getYingshouData(val, this.headerSearch.time)
    },
    getSummaries (param) {
      return [];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 元';
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    getDataList_one () {
      var myChart = echarts.init(document.getElementById('month'))
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: '月份统计',
        },
        tooltip: {},
        legend: {
          data: ['营收额', '回款额', '利润额'],
        },
        xAxis: {
          name: '月份',
          type: 'category',
          data: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
          ],
        },
        yAxis: {
          name: '金额(单位:元)',
        },
        series: [
          {
            name: '营收额',
            type: 'bar',
            label: {
              show: true,
              rotate: 90,
              position: 'inside',
            },
            data: [5, 20, 36, 10, 10, 20, 5, 20, 36, 10, 10, 20],
          },
          {
            name: '回款额',
            type: 'bar',
            label: {
              show: true,
              rotate: 90,
              position: 'inside',
            },
            data: [5, 20, 36, 10, 10, 20, 5, 20, 36, 10, 10, 20],
          },
          {
            name: '利润额',
            type: 'bar',
            label: {
              show: true,
              rotate: 90,
              position: 'inside',
            },
            data: [5, 20, 36, 10, 10, 20, 5, 20, 36, 10, 10, 20],
          },
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    },
    revenueAmount (data) {

    },
  },
}
</script>
<style scoped>
@import '../../../node_modules/@hey_dino/quarter-picker/lib/style/index.css'
</style>